/* ==========================================================================
   MADHOURS - gallery image weight + thumbnail tap-to-jump.

   1) IMAGE WEIGHT
   The theme renders gallery images with a `srcset` full of `w` descriptors but
   NO `sizes`. Per spec the browser then assumes `sizes="100vw"`, so on a 1280px
   desktop it selects the largest candidate available - for these product shots
   the untouched original (3069x3069 and up, several MB) - to paint a 110px
   thumbnail. Those downloads stall, so the strip stays blank on desktop. A
   375px phone resolves 100vw to a small candidate, which is why the same page
   looked fine on mobile.

   Adding `sizes` alone is NOT enough: by the time a deferred script runs the
   browser has committed to a candidate, and changing `sizes` does not restart
   an in-flight fetch. So thumbnails drop `srcset` entirely and pin `src` to an
   explicitly sized CDN URL - deterministic, and it cancels the oversized
   request already running. They also switch to eager: at 260px they are a few
   KB each and all sit in the opening viewport, so lazy-loading bought nothing
   and cost a blank strip whenever the intersection check was slow.

   2) TAP-TO-JUMP
   On phones the swipe rail replaces the stacked hero, and the thumbnail strip
   is shown underneath as photo previews. But the theme's own click handler
   swaps the ORIGINAL hero image - which the rail hides - so tapping a preview
   did nothing visible. The capture-phase handler below intercepts the tap
   first and scrolls the rail to the matching pane instead. It no-ops on
   desktop, where the rail is display:none and the theme's behaviour is correct.
   ========================================================================== */
(function () {
  'use strict';

  var THUMB_W = 260;   // 110px box at 2x DPR, with headroom

  function sizedUrl(raw, width) {
    if (!raw) return null;
    var url = raw.indexOf('//') === 0 ? window.location.protocol + raw : raw;
    if (url.indexOf('/cdn/shop/') === -1 && url.indexOf('cdn.shopify.com') === -1) return null;
    url = url.replace(/([?&])(width|height)=\d+/g, '$1').replace(/[?&]+$/, '').replace(/([?&])&+/g, '$1');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function fixThumbs() {
    var thumbs = document.querySelectorAll(
      '.grid-container img, .grid-container-mobile img, .product-img-grid-item img'
    );
    Array.prototype.forEach.call(thumbs, function (img) {
      if (img.getAttribute('data-mh-sized')) return;
      var next = sizedUrl(img.getAttribute('src'), THUMB_W);
      if (!next) return;
      img.setAttribute('data-mh-sized', '1');
      // Order matters: clearing srcset first stops the oversized candidate from
      // winning source selection again when src changes.
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'async');
      img.setAttribute('fetchpriority', 'low');
      img.setAttribute('src', next);
    });
  }

  function fixHero() {
    var hero = document.querySelectorAll('#main-product-image, .featured-product-image img');
    Array.prototype.forEach.call(hero, function (img) {
      if (!img.getAttribute('srcset')) return;
      if (img.getAttribute('sizes')) return;
      img.setAttribute('sizes', '(min-width: 900px) 620px, 100vw');
    });
  }

  function run() { fixHero(); fixThumbs(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* --- Tap a preview, move the rail ------------------------------------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var item = e.target.closest('.product-img-grid-item');
    if (!item) return;

    var rail = document.querySelector('.mh-swipe');
    // Desktop: no rail, or hidden - let the theme's own hero swap happen.
    if (!rail || !rail.isConnected) return;
    if (window.getComputedStyle(rail).display === 'none') return;

    var strip = item.parentNode;
    var idx = Array.prototype.indexOf.call(strip.children, item);
    var pane = rail.children[idx];
    if (!pane) return;

    // Capture phase + stopPropagation so the theme handler never runs and
    // repaints a hero the shopper cannot see.
    e.preventDefault();
    e.stopPropagation();

    var left = pane.offsetLeft - rail.offsetLeft;
    if (rail.scrollTo) {
      rail.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      rail.scrollLeft = left;
    }
  }, true);

  // The theme re-renders gallery markup on variant change and the product
  // section re-renders on every theme-editor edit. Re-apply sizing then.
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('DOMContentLoaded', function () {
    var box = document.querySelector('.product-image-box');
    if (!box || !window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; run(); });
    }).observe(box, { childList: true, subtree: true });
  });
})();
